import React from 'react';
import { theme } from 'antd';

import { AiInsightsEmptyState } from '../../shared';

export const NO_ACTIVITY_HEADLINE = 'No AI Crawler activity in the selected date range';
export const NO_ACTIVITY_BODY = 'Try expanding your date range or choosing a different crawler.';

function DiscoverabilityNoActivityEmptyState() {
  const { token } = theme.useToken();

  return (
    <div style={{ padding: token.paddingXL }}>
      <AiInsightsEmptyState headline={NO_ACTIVITY_HEADLINE} body={NO_ACTIVITY_BODY} />
    </div>
  );
}

export default DiscoverabilityNoActivityEmptyState;
